module.exports = __webpack_public_path__ + "assets/img/TrendingNow_training.e01aee8d-ps.jpg";